import {AthleteNextGameModuleFetchHandler} from "./athlete-next-game.module.fetch-handler";
import {AthleteNextGameModuleMarketNavigationClickEventHandler} from "./athlete-next-game.module.market-navigation.click-event.handler";
import {PostPredictionHandler} from "../../../../../core/handlers/post-prediction-handler";
import {PredictionClickEventHandler} from "../../../../../core/handlers/prediction-click-event.handler";
import {PredictionShowEventHandler} from "../../../../../core/handlers/prediction.show-event.handler";
import {TimingHandler} from "../../../../../infrastructure/handlers/timing-handler";
import {PopulateDataHandler} from "../../../../../infrastructure/handlers/populate-data-handler";
import {HandlerList} from "../../../../../infrastructure/handlers/handler-list";
import {MatchDetailsClickEventHandler} from "../../../../../core/handlers/match-details.click-event.handler";
import {PropositionBetsPopupDisplayHandler} from "../../../../../core/handlers/proposition-bets.popup-display.handler";

export class AthleteNextGameModuleHandlers extends HandlerList {
  static injectables = [
    AthleteNextGameModuleFetchHandler,
    AthleteNextGameModuleMarketNavigationClickEventHandler,
    PostPredictionHandler,
    PredictionClickEventHandler,
    PredictionShowEventHandler,
    MatchDetailsClickEventHandler,
    PropositionBetsPopupDisplayHandler,
    TimingHandler,
    PopulateDataHandler
  ];

  constructor(
    athleteNexGameModuleFetchHandler: AthleteNextGameModuleFetchHandler,
    athleteNextGameModuleMarketNavigationClickEventHandler: AthleteNextGameModuleMarketNavigationClickEventHandler,
    postPredictionHandler: PostPredictionHandler,
    predictionClickEventHandler: PredictionClickEventHandler,
    predictionShowEventHandler: PredictionShowEventHandler,
    matchDetailsClickEventHandler: MatchDetailsClickEventHandler,
    propositionBetsPopupDisplayHandler: PropositionBetsPopupDisplayHandler,
    timingHandler: TimingHandler,
    populateDataHandler: PopulateDataHandler
  ) {
    super();

    [
      athleteNexGameModuleFetchHandler,
      athleteNextGameModuleMarketNavigationClickEventHandler,
      postPredictionHandler,
      predictionClickEventHandler,
      predictionShowEventHandler,
      matchDetailsClickEventHandler,
      propositionBetsPopupDisplayHandler,
      timingHandler,
      populateDataHandler
    ].forEach(handler => this.add(handler));
  }
}
